const apiRoutes = {
  getTagsRoute: "https://cheatcode.pythonanywhere.com/tags",
  postSubmittedQuestionsRoute: "https://cheatcode.pythonanywhere.com/completed",
};

export default apiRoutes;
